import { IProduct } from './product.store'
import { combos } from './combo-products.data'
import { concat } from 'lodash'

export const products: IProduct[] = concat(combos, [
  {
    sku: 'V9620',
    description: 'Bánh mì xá xiu',
    normalPrice: 30000,
    category: 'bread',
    defaultModifierSkus: []
  },
  {
    sku: 'V0287',
    description: 'Bánh mì thịt nướng mật ong',
    normalPrice: 35000,
    category: 'bread',
    imageLink: require('../img/thit-nuong-mat-ong.jpg'),
    defaultModifierSkus: ['V0081', 'V0087', 'V0091'],
    variants: [
      {
        group: { size: 'big' },
        sku: 'V0287',
        description: 'Cỡ to',
        normalPrice: 35000
      }
    ]
  },
  {
    sku: 'V0098',
    description: 'Bánh mì bò sốt tiêu',
    normalPrice: 35000,
    category: 'bread',
    imageLink: require('../img/bo-sot-tieu.jpg'),
    defaultModifierSkus: ['V0081', 'V0084', 'V0090'],
    variants: [
      {
        group: { size: 'big' },
        sku: 'V0098',
        description: 'Cỡ to',
        normalPrice: 35000
      }
    ]
  },
  {
    sku: 'V2861',
    description: 'Bánh mì trứng thịt',
    normalPrice: 30000,
    category: 'bread',
    defaultModifierSkus: ['V0081', 'V0085', 'V0087']
  },
  {
    sku: 'V2862',
    description: 'Bánh mì trứng thịt pate',
    normalPrice: 35000,
    category: 'bread',
    defaultModifierSkus: ['V0081', 'V0085', 'V0087']
  },
  {
    sku: 'V1036',
    description: 'Bánh mì bơ tỏi',
    normalPrice: 15000,
    category: 'bread'
  },
  {
    sku: 'V8504',
    description: 'Bánh mì pate tự chọn',
    normalPrice: 18000,
    category: 'bread',
    defaultModifierSkus: ['V8517', 'V0085', 'V0091']
  },
  {
    sku: 'V8505',
    description: 'Bánh mì pate thập cẩm',
    normalPrice: 35000,
    category: 'bread',
    defaultModifierSkus: ['V8517', 'V0085', 'V0091']
  },
  {
    sku: 'V8337',
    description: 'Bánh mì trứng tự chọn',
    normalPrice: 18000,
    category: 'bread',
    defaultModifierSkus: ['V0085', 'V0081']
  },
  {
    sku: 'V8338',
    description: 'Bánh mì trứng full topping',
    normalPrice: 39000,
    category: 'bread',
    defaultModifierSkus: ['V0085', 'V0081']
  },
  {
    sku: 'V8502',
    description: 'Bánh mì gà xé sốt cay',
    normalPrice: 30000,
    category: 'bread',
    defaultModifierSkus: ['V8517', 'V8515', 'V0085']
  },
  {
    sku: 'V8503',
    description: 'Bánh mì gà xé',
    normalPrice: 30000,
    category: 'bread',
    defaultModifierSkus: ['V8517', 'V8515', 'V0085']
  },
  {
    sku: 'V8500',
    description: 'Xôi gà xé',
    normalPrice: 35000,
    category: 'sticky-rice',
    defaultModifierSkus: ['V0384', 'V0364', 'V0353']
  },
  {
    sku: 'V8501',
    description: 'Xôi gà xé sốt nấm',
    normalPrice: 40000,
    category: 'sticky-rice',
    defaultModifierSkus: ['V0384', 'V0364', 'V0353']
  },
  {
    sku: 'V0379',
    description: 'Xôi ruốc lạp xưởng',
    normalPrice: 30000,
    category: 'sticky-rice',
    imageLink: require('../img/combo-ruoc-lap-xuong.jpg'),
    defaultModifierSkus: ['V0353', 'V0359', 'V0350', 'V0384', 'V0364', 'V1046']
  },
  {
    sku: 'V0381',
    description: 'Xôi thịt trứng chả',
    normalPrice: 45000,
    category: 'sticky-rice',
    imageLink: require('../img/combo-thit-trung-cha.jpg'),
    defaultModifierSkus: ['V0384']
  },

  {
    sku: 'V1023',
    description: 'Xôi thịt, trứng ốp la',
    normalPrice: 40000,
    category: 'sticky-rice',
    imageLink: require('../img/combo-pate-xuc-xich.jpg'),
    defaultModifierSkus: ['V0353', 'V0355', 'V0364', 'V0384', 'V1046', 'V0543']
  },

  {
    sku: 'V1029',
    description: 'Xôi ruốc, chả, trứng ốp la',
    normalPrice: 25000,
    category: 'sticky-rice',
    imageLink: require('../img/combo-pate-xuc-xich.jpg'),
    defaultModifierSkus: ['V0353', 'V0358', 'V0364', 'V0384', 'V0350', 'V1046', 'V0543']
  },
  {
    sku: 'V0380',
    description: 'Xôi trứng chả pate',
    normalPrice: 30000,
    category: 'sticky-rice'
  },
  {
    sku: 'V0385',
    description: 'Xôi tự chọn',
    normalPrice: 18000,
    category: 'sticky-rice',
    defaultModifierSkus: ['	V0353', 'V0364', 'V0384', 'V1046']
  },
  {
    sku: 'V1410',
    description: 'Khô heo vị bò 50g',
    normalPrice: 15000,
    category: 'other',
    defaultModifierSkus: []
  },
  {
    sku: 'V1409',
    description: 'Khô gà lá chanh 50g',
    normalPrice: 15000,
    category: 'other',
    defaultModifierSkus: []
  },
  {
    sku: 'V0400',
    description: 'Cà phê đen đá 250ml',
    normalPrice: 18000,
    category: 'milk-tea',
    subCat: 'savor-drink',
    defaultModifierSkus: []
  },
  {
    sku: 'V0401',
    description: 'Cà phê sữa đá 250ml',
    normalPrice: 22000,
    category: 'milk-tea',
    subCat: 'savor-drink',
    defaultModifierSkus: []
  },
  {
    sku: 'V1091',
    description: 'Bạc xỉu đá',
    normalPrice: 22000,
    category: 'milk-tea',
    subCat: 'savor-drink',
    defaultModifierSkus: []
  },
  {
    normalPrice: 18000,
    sku: 'V0704',
    description: 'Nước ép chanh leo 500ml',
    variants: [
      {
        group: {
          size: 'small'
        },
        sku: 'V0704',
        description: 'Size M',
        normalPrice: 18000
      }
    ],
    category: 'juice'
  },
  {
    sku: 'V9081',
    description: 'Nước chanh leo (M)',
    normalPrice: 15000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9082',
    description: 'Nước chanh leo (L)',
    normalPrice: 20000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9083',
    description: 'Trà xanh kim quất (M) mới',
    normalPrice: 15000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9084',
    description: 'Trà xanh kim quất (L)',
    normalPrice: 20000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9085',
    description: 'Trà xanh chanh leo (M)',
    normalPrice: 17000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9086',
    description: 'Trà xanh chanh leo (L)',
    normalPrice: 25000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9087',
    description: 'Trà xoài thạch đào (M)',
    normalPrice: 27000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9088',
    description: 'Trà xoài thạch đào (L)',
    normalPrice: 35000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9089',
    description: 'Trà xoài chanh leo thạch đào (M)',
    normalPrice: 27000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    sku: 'V9090',
    description: 'Trà xoài chanh leo thạch đào (L)',
    normalPrice: 35000,
    category: 'milk-tea',
    subCat: 'fruit-tea'
  },
  {
    normalPrice: 25000,
    sku: 'V0710',
    category: 'milk-tea',
    subCat: 'olong-tra',
    description: 'Trà sữa bạc hà',
    variants: [
      {
        group: {
          size: 'small'
        },
        sku: 'V0710',
        description: 'Size M',
        normalPrice: 25000
      }
    ]
  },
  {
    sku: 'V2329',
    description: 'Trà Ô Long nhài sữa trân châu (M)',
    normalPrice: 27000,
    category: 'milk-tea',
    subCat: 'olong-tra'
  },
  {
    sku: 'V2330',
    description: 'Trà Ô Long nhài sữa trân châu (L)',
    normalPrice: 35000,
    category: 'milk-tea',
    subCat: 'olong-tra'
  },
  {
    sku: 'V2327',
    description: 'Trà Ô Long nhài sữa',
    normalPrice: 22000,
    category: 'milk-tea',
    subCat: 'olong-tra',
    variants: [
      {
        group: {
          size: 'small'
        },
        description: 'Size M',
        sku: 'V2327',
        normalPrice: 22000
      },
      {
        group: {
          size: 'big'
        },
        description: 'Size L',
        sku: 'V2328',
        normalPrice: 30000
      }
    ]
  },
  {
    sku: 'V2333',
    description: 'Trà Ô Long kim quất (M)',
    normalPrice: 18000,
    category: 'milk-tea',
    subCat: 'olong-tra'
  },
  {
    sku: 'V2334',
    description: 'Trà Ô Long kim quất (L)',
    normalPrice: 22000,
    category: 'milk-tea',
    subCat: 'olong-tra'
  },
  {
    sku: 'V2331',
    description: 'Trà Ô Long chanh leo (M)',
    normalPrice: 22000,
    category: 'milk-tea',
    subCat: 'olong-tra'
  },
  {
    sku: 'V2332',
    description: 'Trà Ô Long chanh leo (L)',
    normalPrice: 25000,
    category: 'milk-tea',
    subCat: 'olong-tra'
  },
  {
    sku: 'V1050',
    description: 'Đường nâu trân châu sữa size M',
    normalPrice: 30000,
    category: 'milk-tea',
    subCat: 'tiger-sugar',
    variants: [
      {
        group: {
          size: 'small'
        },
        sku: 'V1050',
        description: 'Size M',
        normalPrice: 30000
      }
    ]
  },
  {
    sku: 'V1051',
    description: 'Đường nâu trân châu sữa size L',
    normalPrice: 35000,
    category: 'milk-tea',
    subCat: 'tiger-sugar',
    variants: [
      {
        group: {
          size: 'big'
        },
        sku: 'V1051',
        description: 'Size L',
        normalPrice: 35000
      }
    ]
  },
  {
    normalPrice: 25000,
    category: 'milk-tea',
    subCat: 'hong-tra',
    sku: 'V1804',
    description: 'Trà sữa matcha (M)'
  },
  {
    sku: 'V0608',
    description: 'Trà Sữa TCDD (M)',
    normalPrice: 27000,
    category: 'milk-tea',
    subCat: 'hong-tra',
    defaultModifierSkus: ['V0621', 'V0618']
  },
  {
    sku: 'V0613',
    description: 'Trà Sữa TCDD (L)',
    normalPrice: 35000,
    category: 'milk-tea',
    subCat: 'hong-tra',
    defaultModifierSkus: ['V0621', 'V0618']
  },
  {
    normalPrice: 15000,
    sku: 'V0694',
    description: 'Hồng trà',
    variants: [
      {
        group: {
          size: 'small'
        },
        sku: 'V0694',
        description: 'Size M',
        normalPrice: 15000
      }
    ],
    category: 'milk-tea',
    subCat: 'hong-tra'
  },
  {
    normalPrice: 22000,
    sku: 'V0695',
    description: 'Hồng trà sữa',
    variants: [
      {
        group: {
          size: 'small'
        },
        sku: 'V0695',
        description: 'Size M',
        normalPrice: 22000
      },
      {
        group: {
          size: 'big'
        },
        sku: 'V0696',
        description: 'Size L',
        normalPrice: 30000
      }
    ],
    category: 'milk-tea',
    subCat: 'hong-tra'
  },
  {
    normalPrice: 25000,
    sku: 'V0708',
    description: 'Trà sữa hokkaido',
    variants: [
      {
        group: {
          size: 'small'
        },
        sku: 'V0708',
        description: 'Size M',
        normalPrice: 25000
      }
    ],
    category: 'milk-tea',
    subCat: 'hong-tra'
  },
  {
    normalPrice: 25000,
    sku: 'V0713',
    category: 'milk-tea',
    subCat: 'hong-tra',
    description: 'Hồng trà latte',
    variants: [
      {
        group: {
          size: 'small'
        },
        sku: 'V0713',
        description: 'Size M',
        normalPrice: 25000
      },
      {
        group: {
          size: 'big'
        },
        sku: 'V0714',
        description: 'Size L',
        normalPrice: 32000
      }
    ]
  },
  {
    normalPrice: 25000,
    category: 'milk-tea',
    subCat: 'hong-tra',
    sku: 'V1805',
    description: 'Trà sữa socola (M)'
  },
  {
    normalPrice: 25000,
    category: 'milk-tea',
    subCat: 'hong-tra',
    sku: 'V1807',
    description: 'Trà sữa dưa lưới (M)'
  },
  {
    normalPrice: 25000,
    category: 'milk-tea',
    subCat: 'hong-tra',
    sku: 'V1809',
    description: 'Trà sữa sầu riêng (M)'
  }
  // Phụ kiện
  // {
  //   category: 'gift',
  //   sku: 'V2857',
  //   description: 'Gói tương ớt Chinsu',
  //   normalPrice: 3000
  // },
  // {
  //   category: 'gift',
  //   sku: 'V2340',
  //   description: 'Sữa Dutch Lady',
  //   normalPrice: 10000
  // },
  // {
  //   category: 'gift',
  //   sku: 'V2469',
  //   description: 'Sprite tặng (Baemin) (chai)',
  //   normalPrice: 0
  // },
  // {
  //   category: 'gift',
  //   sku: 'V2470',
  //   description: 'Fanta tặng (Baemin) (chai)',
  //   normalPrice: 0
  // },
  // {
  //   category: 'gift',
  //   sku: 'V2570',
  //   description: 'Pepsi tặng 245ml (ShopeeFood) (lon)',
  //   normalPrice: 10000
  // },
  // {
  //   category: 'gift',
  //   sku: 'V2638',
  //   description: 'Coca lon (tặng kèm đơn Grab)',
  //   normalPrice: 10000
  // },
])
